import { css } from "@emotion/react"
import { PRIMARY_COLOR } from "style"
import { MouseEventHandler, ReactNode } from "react"

type Props = {
  children?: ReactNode
  onClick?:MouseEventHandler<HTMLButtonElement>
}

export const TextButton = (props: Props)=>{
  return(
    <button 
      css={buttonCss}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  )
}

const buttonCss = css`
  border: 0;
  background-color: white;
  color: ${PRIMARY_COLOR};
  font-size: 20px;
  padding: 15px 20px;
`